<template>
  <div class="shopInfo">
    <div class="relative">
      <template v-if="isOpenType == 2">
        <div class="link link-one-other absolute"></div>
        <div class="link link-two-other absolute"></div>
      </template>
      <template v-else>
        <div class="link link-one absolute"></div>
        <div class="link link-two absolute"></div>
      </template>
      <el-form ref="form" :model="form" :rules="rules" label-width="93px">
        <template v-if="isOpenType == 2">
          <div class="form-step fb mar20-b f16"><span class="mar20-r white f12">1</span> 选择企业</div>
          <div class="flex mar50-l mar20-b">
            <el-select
              class="w613"
              v-model="seachOrgId"
              filterable
              remote
              reserve-keyword
              placeholder="请输入关键词"
              :remote-method="queryOrgList"
              @change="getPackage"
            >
              <el-option v-for="item in seachOrgList" :key="item.id" :label="item.name + '-' + item.adminName" :value="item.id"></el-option>
            </el-select>
          </div>
        </template>
        <div v-if="isOpenType == 2" class="form-step fb mar20-b f16"><span class="mar20-r white f12">2</span> 版本选择</div>
        <div v-if="isOpenType != 2" class="form-step fb mar20-b f16"><span class="mar20-r white f12">1</span> 版本选择</div>
        <div class="flex mar50-l mar20-b">
          <div class="pad20 mar20-r border-gray9 radius5 pointer" :class="{ borBlue: shopType === 'MICRO_STORE' }" @click="changeShop('MICRO_STORE')">
            <p class="f16">订到-微店版</p>
            <p class="f12 gray9 mar5-t">一键快速拥有品牌专属小程序</p>
          </div>
          <div class="pad20 mar20-r border-gray9 radius5 pointer" :class="{ borBlue: shopType === 'ORDER_GOODS' }" @click="changeShop('ORDER_GOODS')">
            <p class="f16">订到-订货版</p>
            <p class="f12 gray9 mar5-t">告别电话订货，让客户线上订货</p>
          </div>
        </div>
        <div class="form-step fb mar20-b f16"><span class="mar20-r white f12">2</span> 经营信息</div>
        <div class="mar50-l">
          <el-form-item label="店铺名称：" prop="name">
            <el-input class="w520" v-model="form.name" placeholder="请填写名称"></el-input>
          </el-form-item>
          <el-form-item label="经营类目：" prop="type">
            <el-checkbox-group v-model="type">
              <el-checkbox label="1" name="农资"> {{ "农资" }}</el-checkbox>
              <el-checkbox label="2" name="农牧"> {{ "农牧" }}</el-checkbox>
              <el-checkbox label="3" name="水产品"> {{ "水产品" }}</el-checkbox>
              <el-checkbox label="4" name="农产品"> {{ "农产品" }}</el-checkbox>
              <el-checkbox label="5" name="禽蛋"> {{ "禽蛋" }}</el-checkbox>
            </el-checkbox-group>
          </el-form-item>
          <el-form-item label="所在地：" class="addr-select">
            <el-select v-model="indProvince" placeholder="请选择省/市" @change="provinceChange">
              <el-option v-for="item in province" :key="item.id" :label="item.name" :value="item.id"></el-option>
            </el-select>
            <el-select v-model="indCity" placeholder="请选择市/县" @change="cityChange">
              <el-option v-for="item in city" :key="item.id" :label="item.name" :value="item.id"></el-option>
            </el-select>
            <el-select v-model="indCountry" placeholder="请选择县" @change="countryChange">
              <el-option v-for="item in country" :key="item.id" :label="item.name" :value="item.id"></el-option>
            </el-select>
            <el-select v-model="indTownship" placeholder="请选择乡镇" @change="townshipChange">
              <el-option v-for="item in township" :key="item.id" :label="item.name" :value="item.id"></el-option>
            </el-select>
            <p class="tagInfo" v-if="addShow">请选择省市县</p>
          </el-form-item>
          <el-form-item label="详细地址：" prop="address">
            <el-input class="w520" v-model="form.addr" placeholder="请填写详细地址"></el-input>
            <!--<el-button type="text" @click="checkAmap">选择</el-button>-->
          </el-form-item>
          <el-form-item v-if="isOpenType == 2">
            <el-button type="primary" @click="onSubmitOpen()">立即开通</el-button>
          </el-form-item>
        </div>
        <div v-if="isOpenType != 2" class="form-step fb mar20-b f16"><span class="mar20-r white f12">3</span> 服务订购</div>
        <div v-if="isOpenType != 2">
          <el-form-item class="mar50-l" label="总计费用：">
            <p class="f28 mar10-r" v-if="goodsPriceLoading"><i class="el-icon-loading"></i></p>
            <span class="f30 mar-15-l" v-if="!goodsPriceLoading">￥{{ goodsDetail.goodsPrice.sellFactPrice }}</span>
          </el-form-item>
          <!-- <el-checkbox v-model="checked" class="agreement">
            阅读并同意
            <a href="JavaScript:;" @click="readAgreement"> 《农信用户注册协议》 </a>
          </el-checkbox> -->
          <div class="mar50-l mar20-b">
            <!-- :disabled="!checked" -->
            <el-button class="w150" type="primary" :loading="!isSubmit" @click="onSubmit('')"> 立即订购 </el-button>
          </div>
        </div>
      </el-form>
      <template v-if="orderList && orderList.length > 0 && isOpenType != 2">
        <div class="w600 pad10 border-gray9 radius5 mar40-b" v-for="item in orderList" :key="item.order.orderId">
          <p class="mar10-b f12">你有未完成支付的订单，可直接支付</p>
          <div class="flex items-center justify-between">
            <div class="flex">
              <img class="w70 h70" :src="`${item.orderGoods[0].goodsPic}?imageView2/1/w/100/h/100`" />
              <div class="flex flex-column justify-between mar10-l">
                <p class="f16">{{ item.orderGoods[0].goodsName }}</p>
                <p class="f12 gray6">{{ goodsDetail.nmGoodsIntroduce }}</p>
                <p class="f12 gray6">x {{ item.orderGoods[0].goodsQuantity }}</p>
              </div>
            </div>
            <div class="flex items-center">
              <p class="f28 mar20-r">￥{{ item.order.fMoneyStr }}</p>
              <el-button type="primary" @click="onSubmit(item.order.orderId)">去支付</el-button>
            </div>
          </div>
        </div>
      </template>
    </div>
    <el-dialog title="提示" :visible.sync="centerDialogVisible" width="80%" center>
      <div class="amap-page-container">
        <div :style="{ width: '100%', height: '300px' }">
          <el-amap vid="amap" :plugin="plugin" class="amap-demo"></el-amap>
        </div>
      </div>
      <template #footer>
        <span class="dialog-footer">
          <el-button @click="centerDialogVisible = false">取 消</el-button>
          <el-button type="primary" @click="centerDialogVisible = false">确 定</el-button>
        </span>
      </template>
    </el-dialog>
    <!--平台协议-->
    <agreement :visible.sync="readAgreementVisible"></agreement>
    <div class="shopSuccess" v-show="isSuccess">
      <img src="./shop_success.png" alt="" />
      <div class="box15"></div>
      <p>恭喜，系统开通成功</p>
    </div>
  </div>
</template>

<style lang="scss" scoped>
@import "./index.scss";
</style>
<style>
.shopInfoMag .el-message-box__headerbtn:focus .el-message-box__close,
.shopInfoMag .el-message-box__headerbtn:hover .el-message-box__close {
  color: #909399;
}
.shopInfoMag .el-button--default:hover,
.shopInfoMag.el-button--default:focus {
  background: #ffffff;
  border: 1px solid #dcdfe6;
  color: #606266;
}
.shopInfoMag .el-button--primary,
.shopInfoMag .el-button--primary:hover,
.shopInfoMag.el-button--primary:focus {
  background-color: #0095f1;
  border-color: #0095f1;
  color: #fff;
}
</style>
<script>
import agreement from "@/components/Agreement";

export default {
  comments: {
    agreement,
  },
  data() {
    return {
      shopType: "MICRO_STORE", // 开通的订到店铺类型  MICRO_STORE -- 微店  ORDER_GOODS -- 订货
      isSuccess: false,
      isLoading: false,
      form: {
        name: "",
        addr: "",
        areaId: "",
        areaAxis: "",
        areaName: "",
        audit: "1",
        shopSort: "",
        identityType: "3",
        shopBusinessType: 0,
        shopBusinessTypes: "",
        orgBoId: null,
        boId: null,
        qualificationStatus: 0,
      },
      type: [],
      rules: {
        name: [
          {
            required: true,
            message: "请输入店铺名称",
            trigger: "blur",
          },
          {
            min: 1,
            max: 20,
            message: "名称过长，请重新输入",
            trigger: "blur",
          },
        ],
        addr: [
          {
            required: true,
            message: "请输入详细地址",
            trigger: "blur",
          },
          {
            min: 1,
            max: 50,
            message: "详细地址过长，请重新输入",
            trigger: "blur",
          },
        ],
      },
      province: [],
      city: [],
      country: [],
      township: [],
      indProvince: "",
      indProName: "",
      indCity: "",
      indCityName: "",
      indCountry: "",
      indCountryName: "",
      indTownship: "",
      indTownshipName: "",
      addShow: false,
      checked: false,
      isOpenType: 0,
      centerDialogVisible: false,
      readAgreementVisible: false,
      plugin: [],
      seachName: "",
      orgBoId: "",
      orgname: "",
      isSubmit: true,
      micro_store_goods_id: 0,
      order_goods_id: 0,
      dh_application_id: "",
      wd_application_id: "",
      goodsDetail: {
        goodsPrice: {
          sellFactPrice: "0.00",
        },
      },
      orderMap: [],
      orderList: [],
      seachOrgList: [],
      seachOrgId: "",
      goodsPriceLoading: true,
    };
  },
  created() {
    if (/(nxin.com)$/.test(window.location.host)) {
      document.domain = "nxin.com";
    }
    if (/(dbn.cn)$/.test(window.location.host)) {
      document.domain = "dbn.cn";
    }
    this.isOpenType = this.$route.params.isOpenType;
    if (this.isOpenType == 2 || this.isOpenType == 0) {
      this.$store.commit("app/setIsZhanShi", true);
    }
    this.$store
      .dispatch("app/getAreas", {
        parentId: 0,
      })
      .then((data) => {
        this.province = data || [];
      });
    if (this.isOpenType != 2) {
      this.$store.dispatch("shop/shop/getEnterpriseByBoId").then((res) => {
        if (res.data && res.data.Type === 0) {
          //this.orgBoId = res.data.ID;
          this.$store
            .dispatch("shop/shop/getEnterpriseByDetail", {
              id: res.data.ID,
            })
            .then((resA) => {
              this.form.name = resA.data.name;
              this.form.addr = resA.data.address;
              this.indProvince = resA.data.province !== 0 ? Number(resA.data.province) : "";
              this.indCity = resA.data.city !== 0 ? Number(resA.data.city) : "";
              this.indCountry = resA.data.country !== 0 ? Number(resA.data.country) : "";
              this.provinceChange();
            });
        }
      });
      this.getPackage();
    }
  },
  methods: {
    getPackage() {
      this.$store.dispatch("shop/shop/getPackageGoods").then((data) => {
        this.micro_store_goods_id = data.data.wd_goods_id;
        this.order_goods_id = data.data.dh_goods_id;
        this.dh_application_id = data.data.dh_application_id;
        this.wd_application_id = data.data.wd_application_id;
        this.$store
          .dispatch("orderHome/index/getPackageOrder", {
            orgBoId: this.seachOrgId,
          })
          .then((res) => {
            this.orderMap = res || [];
            this.changeShop(this.shopType);
            this.provinceChange();
          });
      });
    },
    changeShop(type) {
      this.goodsPriceLoading = true;
      this.orderList = [];
      this.checked = false;
      if (this.orderMap && this.orderMap.length > 0) {
        for (const order of this.orderMap) {
          if (order.shop.shopSort === type) {
            this.form = order.shop;
            let orderItem = {
              order: order.order,
              orderGoods: order.orderGoods,
            };
            this.orderList.push(orderItem);
            this.type = order.shop.shopBusinessTypes.split(",");
            this.checked = true;
            //地区回显待处理
            let areaAxis = this.form.areaAxis.split("$");
            areaAxis = areaAxis.slice(1);
            this.indProvince = areaAxis.length && areaAxis[0] ? Number(areaAxis[0]) : "";
            this.indCity = areaAxis.length && areaAxis[1] ? Number(areaAxis[1]) : "";
            this.indCountry = areaAxis.length && areaAxis[2] ? Number(areaAxis[2]) : "";
            this.indTownship = areaAxis.length && areaAxis[3] ? Number(areaAxis[3]) : "";
          }
        }
      }
      this.shopType = type;
      if (this.isOpenType != 2) {
        if (type === "ORDER_GOODS") {
          this.packageGoods(this.order_goods_id);
        } else {
          this.packageGoods(this.micro_store_goods_id);
        }
      }
      if (this.isOpenType == 2) {
        this.seachOrgList.forEach((seachOrg) => {
          if (seachOrg.id == this.seachOrgId) {// eslint-disable-line
            this.form.name = seachOrg.name;
            this.form.addr = seachOrg.address;
            this.form.orgBoId = this.seachOrgId;
            this.form.boId = seachOrg.adminId;
            this.indProvince = seachOrg.province !== 0 ? Number(seachOrg.province) : "";
            this.indCity = seachOrg.city !== 0 ? Number(seachOrg.city) : "";
            this.indCountry = seachOrg.country !== 0 ? Number(seachOrg.country) : "";
            this.provinceChange();
          }
        });
      }
    },
    onSubmitOpen() {
      this.$set(this.form, "isOpenApplication", "0");
      if (this.form.name === "") {
        this.$message.error("请输入店铺名称");
        return;
      }
      this.form.shopSort = this.shopType;
      let idNum = 0;
      this.form.shopBusinessType = 0;
      this.form.shopBusinessTypes = "";
      this.type.forEach((e) => {
        this.form.shopBusinessTypes += `${Number(e)},`;
        this.form.shopBusinessType += Math.pow(2, Number(e) - 1);//eslint-disable-line
        idNum += 1;
      });
      if (idNum === 0) {
        this.$message.error("请选择经营类目！");
        return;
      }
      const number = this.form.shopBusinessTypes.lastIndexOf(",");
      this.form.shopBusinessTypes = this.form.shopBusinessTypes.substring(0, number);
      this.form.audit = "1";
      this.form.qualificationStatus = 1;
      if (this.form.areaId === "") {
        this.$message.error("请选择地区！");
        return;
      }
      if (this.form.addr === "") {
        this.$message.error("请填写详细地址！");
        return;
      }
      this.isSubmit = false;
      this.$confirm("确定要开通系统？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        customClass: "shopInfoMag",
      }).then(() => {
        this.$set(this.form, "isOpenApplication", "1");
        // 调接口
        this.$store.dispatch("shop/shop/getShopApply", this.form).then((res) => {
          if (res.code === "0") {
            // isSuccess
            this.isSuccess = true;
            this.$confirm("开通成功", "提示", {
              confirmButtonText: "确定",
              type: "warning",
              customClass: "shopInfoMag",
              showCancelButton: false,
            }).then(() => {});
            this.isSubmit = true;
          } else {
            this.isSubmit = true;
            this.$message.error(res.msg);
          }
        });
      });
    },
    onSubmit(orderId) {
      this.form.orderId = "";
      if (orderId !== "") {
        this.form.orderId = orderId;
      } else {
        this.form.shopSort = this.shopType;
      }
      if (this.form.name === "") {
        this.$message.error("请输入店铺名称");
        return;
      }
      let idNum = 0;
      this.form.shopBusinessType = 0;
      this.form.shopBusinessTypes = "";
      this.type.forEach((e) => {
        this.form.shopBusinessTypes += `${Number(e)},`;
        this.form.shopBusinessType += Math.pow(2, Number(e) - 1);//eslint-disable-line
        idNum += 1;
      });
      if (idNum === 0) {
        this.$message.error("请选择经营类目！");
        return;
      }
      const number = this.form.shopBusinessTypes.lastIndexOf(",");
      this.form.shopBusinessTypes = this.form.shopBusinessTypes.substring(0, number);
      this.form.qualificationStatus = 1;
      if (this.isOpenType === "0") {
        this.form.audit = "1";
      }
      if (this.form.areaId === "") {
        this.$message.error("请选择地区！");
        return;
      }
      if (this.form.addr === "") {
        this.$message.error("请填写详细地址！");
        return;
      }
      this.isSubmit = false;
      this.$confirm("确定要开通系统？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        customClass: "shopInfoMag",
      })
        .then(() => {
          // 调接口
          this.$store.dispatch("shop/shop/getShopByAnticipate", this.form).then((res) => {
            if (res.code === "0" && res.data.result.success) {
              window.open(`${process.env.VUE_APP_APP}payment/chectout/bkCheckout/` + res.data.orderId, "_blank");
              this.isSubmit = true;
              this.open();
            } else {
              this.isSubmit = true;
              this.$message.error(res.msg);
            }
          });
        })
        .catch(() => {
          this.isSubmit = true;
        });
    },
    // 选择省份
    provinceChange() {
      this.city = [];
      this.province.forEach((item) => {
        if (item.id === this.indProvince) {
          this.indProName = item.name;
        }
      });
      this.$store
        .dispatch("app/getAreas", {
          parentId: this.indProvince,
        })
        .then((data) => {
          this.city = data || [];
          this.cityChange();
        });
    },

    // 选择市
    cityChange() {
      this.country = [];
      this.city.forEach((item) => {
        if (item.id === this.indCity) {
          this.indCityName = item.name;
        }
      });
      this.$store
        .dispatch("app/getAreas", {
          parentId: this.indCity,
        })
        .then((data) => {
          this.country = data || [];
          this.countryChange();
        });
    },
    // 选择县区
    countryChange() {
      this.township = [];
      this.country.forEach((item) => {
        if (item.id === this.indCountry) {
          this.indCountryName = item.name;
        }
      });
      this.form.areaId = this.indCountry;
      this.form.areaAxis = `$${this.indProvince}$${this.indCity}$${this.indCountry}`;
      this.form.areaName = this.indProName + this.indCityName + this.indCountryName;
      this.$store
        .dispatch("app/getAreas", {
          parentId: this.indCountry,
        })
        .then((data) => {
          this.township = data || [];
          this.townshipChange();
        });
    },
    // 选择县区
    townshipChange() {
      this.township.forEach((item) => {
        if (item.id === this.indTownship) {
          this.indTownshipName = item.name;
        }
      });
      this.form.areaId = this.indTownship;
      this.form.areaAxis = `$${this.indProvince}$${this.indCity}$${this.indCountry}$${this.indTownship}`;
      this.form.areaName = this.indProName + this.indCityName + this.indCountryName + this.indTownshipName;
    },
    checkAmap() {
      this.centerDialogVisible = true;
      this.init();
    },
    readAgreement() {
      this.readAgreementVisible = true;
    },
    // 高德地图
    init() {
      this.plugin = [
        {
          enableHighAccuracy: true,
          timeout: 100,
          maximumAge: 0,
          convert: true,
          showButton: true,
          buttonPosition: "RB",
          showMarker: true,
          showCircle: true,
          panToLocation: true,
          zoomToAccuracy: true,
          extensions: "all",
          pName: "Geolocation",
          events: {
            init(o) {
              // o 是高德地图定位插件实例
              o.getCurrentPosition((status, result) => {
                console.log(result);
              });
            },
          },
        },
      ];
    },
    // 套餐商品价格
    packageGoods(goodsId) {
      const param = {
        goodsId: goodsId,
      };
      this.$store.dispatch("goods/goods/detail", this.$qs.stringify(param)).then((data) => {
        this.goodsDetail = data.data || {};
        this.goodsPriceLoading = false;
      });
    },
    // 查询组织列表
    queryOrgList(query) {
      if (query !== "") {
        const param = {
          open_req_src: "nxmall_agr",
          name: query,
        };
        setTimeout(() => {
          this.$store.dispatch("shop/shop/getOrgList", param).then((res) => {
            this.seachOrgList = res.data.filter((item) => {
              return !item.group && item.name.toLowerCase().indexOf(query.toLowerCase()) > -1;
            });
          });
        }, 500);
      } else {
        this.seachOrgList = [];
      }
    },
    open() {
      const h = this.$createElement;
      this.$msgbox({
        title: "消息",
        message: h("p", null, [h("span", null, "如果没弹出支付页面，可能被您的浏览器拦截了！ "), h("span", null, "请检查浏览器设置")]),
        showCancelButton: true,
        confirmButtonText: "我已支付完成",
        cancelButtonText: "遇到问题，重试",
        customClass: "shopInfoMag",
        beforeClose: (action, instance, done) => {
          if (action === "confirm") {
            instance.confirmButtonLoading = true;
            instance.confirmButtonText = "跳转中...";
            setTimeout(() => {
              // eslint-disable-next-line max-len
              window.top.location = `${process.env.VUE_APP_HOME}trade/default?iframeUrl=${process.env.VUE_APP_APP}v/orderHome`;
            }, 2000);
          } else {
            done();
          }
        },
      })
        .then(() => {})
        .catch(() => {
          window.location.reload(true);
        });
    },
  },
};
</script>
